import React, {useEffect} from 'react';
import IconaMenu from './IconaMenu'
import { haPersonalizzazione } from '../funzioni.js';

function PrenotazioniMenu(props) {    
    const iconaPrenotaPerCorso = require('./prenotapercorso.png');
    const iconaPrenotaPerGiorno = require('./prenotapergiorno.png');
    const iconaLeTuePrenotazioni = require('./elencoprenotazioni.png');
    const iconaElenco = require('./convocati.png');

    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.home);            
        } 
    }, [props.flagRichiestaBack])

    var oggetto = "corso";
    if (haPersonalizzazione(props.identitaSelezionata, "prenotazioni_campo")) oggetto = "campo";

    return (

        <div
            style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Centra verticalmente (perché la flexDirection è column) tutto il contenuto
            marginLeft: 5,
            marginRight: 5,
            }}
        >

            {!haPersonalizzazione(props.identitaSelezionata, "prenotazioni_iscritti_readonly") &&
                <div style={{display:"flex", flexDirection:"row", justifyContent:"center"}}>
                    <IconaMenu
                        callback={() => props.callback(props.PAGINECLIENTI.prenotazioni)}
                        immagine={iconaPrenotaPerCorso}
                        testo={"Prenota\nper "+oggetto}
                    />
                    <IconaMenu
                        callback={() => props.callback(props.PAGINECLIENTI.prenotazioniCorsiOggi)}
                        immagine={iconaPrenotaPerGiorno}
                        testo={"Prenota\nper giorno"}
                    />                
                </div>
            }
            {props.identitaSelezionata.flag_staff && !haPersonalizzazione(props.identitaSelezionata, "prenotazioni_iscritti_readonly") ?
                <div style={{display:"flex", flexDirection:"row", justifyContent:"center"}}>
                    <IconaMenu
                        callback={() =>{                            
                            props.callback(props.PAGINECLIENTI.prenotazioniElencoIscritto);
                        }}
                        immagine={iconaLeTuePrenotazioni}
                        testo={"Le tue\nPrenotazioni"}
                    />    
                    <IconaMenu
                        callback={() =>{                            
                            props.callback(props.PAGINECLIENTI.prenotazioniElenco);
                        }}
                        immagine={iconaElenco}
                        testo={"Elenco\nPrenotazioni"}
                    />                        
                </div>
            :
                <div style={{display:"flex", flexDirection:"row", justifyContent:"center"}}>
                    <IconaMenu
                        callback={() =>{
                            props.callback(props.PAGINECLIENTI.prenotazioniElencoIscritto);
                        }}
                        immagine={iconaLeTuePrenotazioni}
                        testo={"Le tue\nPrenotazioni"}
                    />    
                </div>
            }
        </div>
    )
}

export default PrenotazioniMenu;
